import React from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import background from "../Media/1900-539.png";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

export default function OurGoal({ im, caption, txt, btn, bgcolor }) {
  const lang = Cookies.get("i18next");
  const matches = useMediaQuery("(min-width:1055px)");
  const { t } = useTranslation();
  const s1 = {
    width: "350px",
  };
  const s2 = {
    width: "250px",
  };
  const s3 = {
    height: "300px",
  };
  const s4 = {
    height: "200px",
  };
  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        objectFit: "cover",
        height: "750px",
        position: "relative",
        backgroundRepeat: "no-repeat",
        marginTop: "2%",
      }}
    >
      <Container>
        <Stack
          direction="row"
          sx={{
            position: "absolute",
            top: "2%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
          gap={matches ? 20 : 0}
        >
          {im && (
            <Box
              sx={{
                width: matches ? s1 : s2,
                display: "flex",
                marginTop: "10%",
                flexWrap: "wrap",
                height: matches ? s3 : s4,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "20px",
                backgroundColor: `${bgcolor}`,
              }}
            >
              <img
                src={im}
                alt="img8"
                style={{
                  width: matches ? "350px" : "200px",
                  marginTop: matches ? "-50px" : "0px",
                  objectFit: "cover",
                  borderRadius: "20px",
                }}
              />
            </Box>
          )}

          <Box sx={{ width: "50%", marginTop: "20px" }}>
            <Typography
              sx={{
                marginBottom: "5%",
                color: "white",
                fontSize:
                  matches && lang === "en"
                    ? "35px"
                    : matches && lang === "ar"
                    ? "35px"
                    : "15px",
                fontWeight: "bold",
              }}
            >
              {t(caption)}
            </Typography>
            <Typography
              sx={{
                fontSize:
                  matches && lang === "en"
                    ? "20px"
                    : matches && lang === "ar"
                    ? "25px"
                    : "12px",
                color: "gray",
              }}
            >
              {t(txt)}
            </Typography>
            {btn && (
              <Button
                sx={{
                  backgroundColor: "white",
                  padding: "10px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  color: "#1D2877",
                  marginTop: matches ? "30px" : "5px",
                  width: matches ? "200px" : "150px",
                }}
              >
                <a
                  className="nav-link"
                  href="https://play.google.com/store/apps/details?id=com.ma.ma_app_client"
                >
                  {t(btn)}
                </a>
              </Button>
            )}
          </Box>
        </Stack>
      </Container>
    </div>
  );
}
